/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentPaymentSerialViewModel } from "../types/IndividualPaymentPaymentSerialViewModel.ts";

export const individualPaymentPaymentSerialViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  nsuDate: z.optional(z.string().datetime()),
  serial: z.optional(z.number().int()),
  situation: z.string().nullish(),
  station: z.string().nullish(),
  ticket: z.string().nullish(),
  typeAmbient: z.string().nullish(),
  digitableLine: z.string().nullish(),
  pdfFileUrl: z.string().nullish(),
  active: z.optional(z.boolean()),
  cancellationDate: z.string().datetime().nullish(),
  paid: z.optional(z.boolean()),
  paidDate: z.string().datetime().nullish(),
}) as unknown as ToZod<IndividualPaymentPaymentSerialViewModel>;
